import { CLOSE, OPEN } from '../../utils/constants';
import { selectedAddons, setSelectedAddons } from '../../utils/variables';
import { addProcedure } from './procedureActions';

export function addAddons(idProcedure, idAddon) {
    idProcedure = parseInt(idProcedure);
    idAddon = parseInt(idAddon);

    let addons = [
        ...selectedAddons,
        {
            id: idAddon,
            procedureId: idProcedure,
        },
    ];
    setSelectedAddons(addons);

    /* Change the checkbox */
    const checkBoxes = document.querySelectorAll(
        `.addon__checkbox[data-procedure-id="${idProcedure}"][data-addon-id="${idAddon}"]`
    );
    checkBoxes.forEach((i) => i.classList.add('is-checked'));

    updateAfterChangeAddon(idProcedure, idAddon, addons);
}

export function removeAddons(idProcedure, idAddon) {
    idProcedure = parseInt(idProcedure);
    idAddon = parseInt(idAddon);

    let addons = selectedAddons.filter(
        (i) => !(i.id === idAddon && i.procedureId === idProcedure)
    );
    setSelectedAddons(addons);

    /* Change the checkbox */
    const checkBoxes = document.querySelectorAll(
        `.addon__checkbox[data-procedure-id="${idProcedure}"][data-addon-id="${idAddon}"]`
    );
    checkBoxes.forEach((i) => i.classList.remove('is-checked'));

    updateAfterChangeAddon(idProcedure, idAddon, addons);
}

function updateAfterChangeAddon(idProcedure, idAddon, selectedAddons) {
    /* Check to enable Add-Ons button */
    const btn = document.querySelectorAll(
        `.addons__applyAddonBtn[data-procedure-id="${idProcedure}"]`
    );
    if (selectedAddons.length > 0) {
        btn.forEach((i) => i.classList.remove('disabled'));
        btn.forEach((i) => i.classList.add('enabled'));
    } else {
        btn.forEach((i) => i.classList.add('disabled'));
        btn.forEach((i) => i.classList.remove('enabled'));
    }

    /* Change count addon */
    const counts = document.querySelectorAll(
        `.checkbox__count[data-procedure-id="${CSS.escape(idProcedure)}"]`
    );
    counts.forEach((i) => {
        i.textContent = selectedAddons.filter(
            (i) => i.procedureId === idProcedure
        ).length;
    });

    /* Check unable/disabled Apply button in addon description popup */
    const applyBtn = document.querySelectorAll(
        `.addonBody__applyBtn[data-procedure-id="${idProcedure}"][data-addon-id="${idAddon}"]`
    );
    if (
        selectedAddons.find(
            (i) => i.id === idAddon && i.procedureId === idProcedure
        )
    ) {
        applyBtn.forEach((i) => i.classList.add('disabled'));
    } else applyBtn.forEach((i) => i.classList.remove('disabled'));
}

export function removeAllAddons(idProcedure) {
    idProcedure = parseInt(idProcedure);

    let addons = selectedAddons.filter((i) => i.procedureId !== idProcedure);
    setSelectedAddons(addons);

    clearCheckedAddon(idProcedure);

    /* Change count addon */
    document
        .querySelectorAll(
            `.checkbox__count[data-procedure-id="${CSS.escape(idProcedure)}"]`
        )
        .forEach((i) => (i.textContent = 0));

    /* Change procedure checkbox */
    const checkBoxes = document.querySelectorAll(
        `.procedure__checkbox[data-procedure-id="${CSS.escape(idProcedure)}"]`
    );
    checkBoxes.forEach((i) => {
        i.classList.remove('is-checked', 'count');
    });

    /* Check to enable Add-Ons button */
    const btn = document.querySelectorAll(
        `.addons__applyAddonBtn[data-procedure-id="${idProcedure}"]`
    );
    /* Disable button in apply Add-Ons  */
    btn.forEach((i) => {
        i.classList.remove('enabled');
        i.classList.add('disabled');
    });

    /* Check unable/disabled Apply button in addon description popup */
    const applyBtn = document.querySelectorAll(
        `.addonBody__applyBtn[data-procedure-id="${idProcedure}"]`
    );
    if (addons.find((i) => i.procedureId === idProcedure)) {
        applyBtn.forEach((i) => i.classList.add('disabled'));
    } else applyBtn.forEach((i) => i.classList.remove('disabled'));
}

export function isCheckedAddons(idProcedure, idAddon) {
    idProcedure = parseInt(idProcedure);
    idAddon = parseInt(idAddon);

    if (
        selectedAddons.find(
            (i) => i.id === idAddon && i.procedureId === idProcedure
        )
    ) {
        return true;
    } else return false;
}

export function toggleAddonsPopup(procedureId, category, state) {
    const addonSectionClassName = `.addonsSections__wrapper[data-procedure-id=${CSS.escape(procedureId)}][data-category=${CSS.escape(category)}]`;
    const addonSection = document.querySelector(addonSectionClassName);

    if (state === OPEN) {
        addonSection.classList.add('popup__open');
        addonSection.querySelector('.addonsSection__content').classList.add('addonsSection__content--selected');
        addonSection.querySelector('.popup__background').classList.remove('fadeOut');
        addonSection.querySelector('.popup__background').style.willChange = 'opacity';
        addonSection.querySelector('.popup__background').addEventListener('animationend', () => {
            addonSection.querySelector('.popup__background').style.willChange = 'auto';
        }, { once: true });
        addonSection.querySelector('.popup__background').classList.add('fadeIn');
        addonSection.querySelector('.addonsSection__content').classList.remove('fadeOutDown');
        addonSection.querySelector('.addonsSection__content').style.willChange = 'transform, opacity';
        addonSection.querySelector('.addonsSection__content').addEventListener('animationend', () => {
            addonSection.querySelector('.addonsSection__content').style.willChange = 'auto';
        }, { once: true });
        addonSection.querySelector('.addonsSection__content').classList.add('fadeInUp');
    } else if (state === CLOSE) {
        addonSection.querySelector('.addonsSection__content').addEventListener('animationend', () => {
            addonSection.querySelector('.addonsSection__content').style.willChange = 'auto';
            addonSection.querySelector('.popup__background').style.willChange = 'auto';
            addonSection.classList.remove('popup__open');
            addonSection.querySelector('.addonsSection__content').classList.remove('fadeOutDown');
        }, { once: true });
        addonSection.querySelector('.addonsSection__content').classList.remove('addonsSection__content--selected');

        addonSection.querySelector('.popup__background').classList.remove('fadeIn');
        addonSection.querySelector('.popup__background').style.willChange = 'opacity, visibility';
        addonSection.querySelector('.popup__background').classList.add('fadeOut');
        
        addonSection.querySelector('.addonsSection__content').classList.remove('fadeInUp');
        addonSection.querySelector('.addonsSection__content').classList.add('fadeOutDown');
    }
}

export function clearCheckedAddon(procedureId) {
    const checkedBox = document.querySelectorAll(
        `.addon__checkbox[data-procedure-id="${CSS.escape(procedureId)}"]`
    );

    checkedBox.forEach((i) => {
        i.classList.remove('is-checked');
    });
}

export function applyAddons(procedureId) {
    const checkBoxes = document.querySelectorAll(
        `.procedure__checkbox[data-procedure-id="${CSS.escape(procedureId)}"]`
    );
    checkBoxes.forEach((i) => i.classList.add('is-checked', 'count'));

    /* Add procedure */
    addProcedure(procedureId);
}

export function toggleAddonDescription(procedureId, addonId, category, state) {
    const descriptionWrapper = document.querySelector(
        `.addonBody__wrapper-line[data-procedure-id="${CSS.escape(
            procedureId
        )}"][data-addon-id="${CSS.escape(addonId)}"]`
    );
    let showAddons = descriptionWrapper.classList.contains('show-addons');
    document.querySelectorAll('.show-addons').forEach(item => {
        item.classList.remove('show-addons');
    });
    if(showAddons) {
        descriptionWrapper.classList.add('show-addons');
    }
    descriptionWrapper.classList.toggle('show-addons');
}

export function applyAddon(procedureId, addonId, category) {
    addAddons(procedureId, addonId);

    toggleAddonDescription(procedureId, addonId, category, CLOSE);
}


